/**
 * Resource séc
 * hkcuong 23.12.2025
 */
export default {
  Title: "Nhập khẩu phát hành Séc",
  ImportedChequeResult:  'Danh sách chứng từ phát hành Séc nhập khẩu thành công',
  ImportedDecisionResult:  'Danh sách Quyết định nhập khẩu thành công',
  ImportedObjectResult: 'Danh sách Đối tượng nhập khẩu thành công',
  
  // Import messages
  DownloadResult: 'Tải kết quả',
  CannotContinueImport: 'Không thể tiếp tục nhập khẩu',
  
  // ImportedChequeList columns
  ImportedChequeList: {
    AreaCode: 'Khu vực',
    RefType: 'Loại CT',
    RefNo: 'Số CT',
    RefDate: 'Ngày CT',
    Description:  'Diễn giải',
    TotalAmount: 'Số tiền',
    VoucherListId: 'Chứng từ nghiệp vụ khác tham chiếu'
  },
  
  // ImportedObjectList columns
  ImportedObjectList: {
    ObjectCode: 'Mã đối tượng',
    ObjectName: 'Tên đối tượng',
    ObjectTypeName:  'Loại đối tượng',
    AreaCode: 'Mã khu vực'
  },
  
  // ImportedDecisionList columns
  ImportedDecisionList: {
    DecisionAlias: 'Số QĐ',
    DecisionDate:  'Ngày QĐ',
    DecisionType:  'Loại QĐ',
    DecisionGroupName: 'Nhóm QĐ',
    AreaCode: 'Mã khu vực',
    DecisionName: 'Tên QĐ'
  }
};
